//   document.addEventListener("DOMContentLoaded", function () {
//     document.body.addEventListener("click", function (e) {
//       const btn = e.target.closest(".yotpo-sr-bottom-line-summary");
//       if (btn) {
//         e.preventDefault();
//         const reviewSection = document.querySelector(".yotpo-widget-instance-custom");
//         if (reviewSection) {
//           reviewSection.scrollIntoView({ behavior: "smooth", block: "start" });
//         }
//       }
//     });
//   });

 
// document.addEventListener("DOMContentLoaded", function () {
//     const observer = new MutationObserver(() => {
//       const starsContainer = document.querySelector('.star-container')?.parentElement?.parentElement;
//       if (starsContainer && !starsContainer.querySelector('.custom-rating-text')) {
//         document.querySelectorAll('.star-container').forEach((span, index) => {
//           if(index == 4) {
            
//             span.classList.remove('yotpo-sr-star-empty');
//             span.classList.add('yotpo-sr-star-half');
//             span.innerHTML= `<defs>
// 		    <linearGradient id="yotpo_stars_gradient_0.8563926457371702">
// 		        <stop offset="51%" stop-color="#F0CD66"></stop>
// 		        <stop stop-opacity="1" offset="51%" stop-color="#FFFFFF"></stop>
// 			</linearGradient>
// 		</defs><path style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="#F0CD66" fill="url('#yotpo_stars_gradient_0.8563926457371702')"></path>`;
//           } else {
//             span.classList.remove('yotpo-sr-star-empty');
//             span.classList.add('yotpo-sr-star-full');
//             span.innerHTML= `<defs>
//                 <linearGradient id="yotpo_stars_gradient_0.28508708046692344">
//                     <stop offset="100%" stop-color="#F0CD66"></stop>
//                     <stop stop-opacity="1" offset="100%" stop-color="#FFFFFF"></stop>
//               </linearGradient>
//             </defs><path style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="#F0CD66" fill="url('#yotpo_stars_gradient_0.28508708046692344')"></path>`;
//           }
          
//         });
//         const textEl = document.createElement('span');
//         textEl.className = 'custom-rating-text';
//         textEl.textContent = 'Rated 4.8 out of 5 stars';
//         starsContainer.appendChild(textEl);
//       }
//     });

//     observer.observe(document.body, { childList: true, subtree: true });
// });




// document.addEventListener("DOMContentLoaded", function () {
//   function hideSectionIfNoReviews() {
//     const reviewLabel = document.querySelector('.reviews-qa-label');
//     const reviewAppsection = reviewLabel?.closest('.shopify-section');
//     const yotpoSection = document.querySelector('.yotpo-widget-instance-custom')?.closest('.shopify-section');

//     if (reviewLabel && reviewLabel.textContent.includes("0 Reviews")) {
//       if (yotpoSection) yotpoSection.style.display = "block";
//       if (reviewAppsection) reviewAppsection.style.display = "none";
//       return true; // 0 reviews → RUN syncYotpoReviews
//     } else {
//       if (yotpoSection) yotpoSection.style.display = "none";
//       if (reviewAppsection) reviewAppsection.style.display = "block";
//       return false; // has reviews → DON'T run syncYotpoReviews
//     }
//   }

//   function syncYotpoReviews(root = document) {
//     let changed = 0;
//     const baseText = root.querySelector(".yotpo-bottom-line-basic-text");
//     if (baseText) {
//       const match = baseText.textContent.match(/Based on\s+(\d+)\s+reviews/i);
//       if (match) {
//         const reviewCount = match[1];
//         root.querySelectorAll(".yotpo-sr-bottom-line-text--right-panel").forEach(span => {
//           if (span.dataset.patched === "1") return;
//           span.textContent = `${reviewCount} Reviews`;
//           span.dataset.patched = "1";
//           changed++;
//         });
//       }
//     }
//     return changed;
//   }

//   function runAll() {
//     const isZeroReviews = hideSectionIfNoReviews();
//     if (isZeroReviews) {
//       syncYotpoReviews();
//     }
//   }

//   // Initial run
//   runAll();

//   // On load
//   window.addEventListener("load", runAll);

//   // Observe Yotpo async render
//   const observer = new MutationObserver(() => {
//     clearTimeout(window.__yotpoPatchTimer);
//     window.__yotpoPatchTimer = setTimeout(runAll, 50);
//   });
//   observer.observe(document.body, { childList: true, subtree: true });

//   // Shopify section reload events
//   document.addEventListener("shopify:section:load", runAll);
//   document.addEventListener("shopify:section:unload", runAll);
// });


// document.addEventListener("DOMContentLoaded", function () {
//   function isZeroReviews() {
//     const reviewLabel = document.querySelector('.reviews-qa-label');
//     return reviewLabel && reviewLabel.textContent.includes("0 Reviews");
//   }

//   // ⭐ Force rating to 4.8
//   function patchYotpoRating(root = document) {
//     const ratingEl = root.querySelector(".yotpo-bottom-line-left-panel.yotpo-bottom-line-score");
//     if (ratingEl && ratingEl.dataset.patched !== "1") {
//       ratingEl.childNodes.forEach(node => {
//         if (node.nodeType === 3 && node.textContent.trim().match(/^\d+(\.\d+)?$/)) {
//           node.textContent = "4.8"; // 👈 forced rating
//         }
//       });
//       ratingEl.dataset.patched = "1";
//     }
//   }

//   // 🧹 Remove "Based on"
//   function patchYotpoBasedOn(root = document) {
//     const el = root.querySelector(".yotpo-bottom-line-basic-text");
//     if (el && el.dataset.cleaned !== "1") {
//       el.textContent = el.textContent.replace(/^Based on\s*/i, "");
//       el.dataset.cleaned = "1";
//     }
//   }

//   function runAll(root = document) {
//     if (isZeroReviews()) {
//       patchYotpoRating(root);
//       patchYotpoBasedOn(root);
//     }
//   }

//   // Run once on load
//   runAll();

//   window.addEventListener("load", runAll);

//   // Observe Yotpo async renders
//   const observer = new MutationObserver(() => {
//     clearTimeout(window.__yotpoPatchTimer3);
//     window.__yotpoPatchTimer3 = setTimeout(runAll, 50);
//   });
//   observer.observe(document.body, { childList: true, subtree: true });

//   // Shopify section reload
//   document.addEventListener("shopify:section:load", runAll);
// });
 

// (function () {
//   function patchYotpoRatings(root = document) {
//     const ratingEl = root.querySelector(".avg-score.font-color-gray-darker");
//     if (ratingEl && ratingEl.dataset.patched !== "1") {
//       ratingEl.childNodes.forEach(node => {
//         if (node.nodeType === 3 && node.textContent.trim().match(/^\d+(\.\d+)?$/)) {
//           node.textContent = "4.8"; // 👈 forced rating
//         }
//       });
//       ratingEl.dataset.patched = "1";
//     }
//   }

//   function run() { patchYotpoRatings(); }

//   document.addEventListener("DOMContentLoaded", run);
//   window.addEventListener("load", run);

//   const obs = new MutationObserver(() => {
//     clearTimeout(window.__yotpoPatchTimer);
//     window.__yotpoPatchTimer = setTimeout(run, 50);
//   });
//   obs.observe(document.body, { childList: true, subtree: true });

//   document.addEventListener("shopify:section:load", run);
// })();

document.addEventListener("DOMContentLoaded", function () {
    document.body.addEventListener("click", function (e) {
      const btn = e.target.closest(".yotpo-sr-bottom-line-summary");
      if (btn) {
        e.preventDefault();
        const reviewSection = document.querySelector(".yotpo-widget-instance-custom");
        if (reviewSection) {
          reviewSection.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    });
  });

 
document.addEventListener("DOMContentLoaded", function () {
    const STAR_PATH = "M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z";

    // Monotonic counter for injected gradient ids. A positional index is unsafe:
    // each observer callback re-indexes from 0, so a widget painted in an earlier
    // callback can collide with a sibling painted later, and the visible stars then
    // resolve to a hidden copy's zero-size gradient and render unfilled.
    let starGradientUid = 0;

    // Paints one star filled to `fraction` (0-1) using Yotpo's own gradient technique.
    // Yotpo's native stars round to the nearest half, so 4.7 would draw as 4.5. This
    // paints the true fraction, matching how the site-wide path renders its row.
    function paintStar(span, fraction, uid, index) {
      const pct = Math.max(0, Math.min(100, Math.round(fraction * 100)));
      const id = `pc_stars_gradient_${uid}_${index}`;
      span.classList.remove('yotpo-sr-star-empty', 'yotpo-sr-star-half', 'yotpo-sr-star-full');
      span.classList.add(pct >= 100 ? 'yotpo-sr-star-full' : (pct > 0 ? 'yotpo-sr-star-half' : 'yotpo-sr-star-empty'));
      span.innerHTML = `<defs>
                  <linearGradient id="${id}">
                      <stop offset="${pct}%" stop-color="#F0CD66"></stop>
                      <stop stop-opacity="1" offset="${pct}%" stop-color="#FFFFFF"></stop>
                </linearGradient>
              </defs><path style="pointer-events: none;" d="${STAR_PATH}" stroke="#F0CD66" fill="url('#${id}')"></path>`;
    }

    const observer = new MutationObserver(() => {
      // Every summary on the page, not just the first. A PDP renders the row twice -
      // a mobile copy and a desktop copy - and the old code only ever touched
      // document.querySelector('.star-container'), i.e. the mobile one. That is why
      // the visible desktop row so often showed a bare count with no rating text.
      const summaries = document.querySelectorAll('.yotpo-sr-bottom-line-summary');
      let patched = 0;

      summaries.forEach(summary => {
        const starsContainer = summary.querySelector('.star-container')?.parentElement?.parentElement;
        if (!starsContainer) return;

        // This file serves the per-product path, so the rating comes from the
        // product's own score rather than the site-wide aggregate. The previous code
        // painted a fixed 4.5 regardless of the real value; this paints the actual
        // score, which Yotpo publishes on the summary element's accessible label.
        const labelEl = starsContainer.closest('[aria-label]') || summary;
        const label = labelEl.getAttribute('aria-label') || '';
        const scoreMatch = label.match(/([\d.]+)\s+out\s+(?:of\s+)?5\s+stars/i);
        if (!scoreMatch) return;
        const score = parseFloat(scoreMatch[1]);
        if (!isFinite(score) || score <= 0 || score > 5) return;

        // Keyed on the score so a later correction repaints, instead of the old
        // "run once, ever" guard which froze whichever value rendered first.
        if (starsContainer.dataset.pcRating === String(score)) return;
        starsContainer.dataset.pcRating = String(score);

        const uid = ++starGradientUid;
        summary.querySelectorAll('.star-container').forEach((span, index) => {
          paintStar(span, score - index, uid, index);
        });

        let textEl = starsContainer.querySelector('.custom-rating-text');
        if (!textEl) {
          textEl = document.createElement('span');
          textEl.className = 'custom-rating-text';
          starsContainer.appendChild(textEl);
        }
        textEl.textContent = ` Rated ${score}/5 Stars`;
        patched++;
      });

      if (patched > 0) {
        setTimeout(function() {
          document.querySelectorAll(".yotpo-widget-instance").forEach(el => {
            el.classList.add("yotpo-ready");
          });
        }, 500)
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
});




document.addEventListener("DOMContentLoaded", function () {
  function hideSectionIfNoReviews() {
    const reviewLabel = document.querySelector('.reviews-qa-label');
    const reviewAppsection = reviewLabel?.closest('.shopify-section');
    const yotpoSection = document.querySelector('.yotpo-widget-instance-custom')?.closest('.shopify-section');

    if (reviewLabel && reviewLabel.textContent.includes("0 Reviews")) {
      if (yotpoSection) yotpoSection.style.display = "block";
      if (reviewAppsection) reviewAppsection.style.display = "none";
      return true; // 0 reviews → RUN syncYotpoReviews
    } else {
      if (yotpoSection) yotpoSection.style.display = "none";
      if (reviewAppsection) reviewAppsection.style.display = "block";
      return false; // has reviews → DON'T run syncYotpoReviews
    }
  }

  function syncYotpoReviews(root = document) {
    // Check if root is a valid DOM element
    if (!(root instanceof Element) && !(root instanceof Document)) {
      root = document;
    }
    
    let changed = 0;
    const baseText = root.querySelector(".yotpo-bottom-line-basic-text");
    if (baseText) {
      // "Based on " is optional: patchYotpoBasedOn() strips that prefix from the same
      // node off an independent observer, so whichever fires first wins. Requiring the
      // prefix meant a stripped node could never match again.
      const match = baseText.textContent.match(/(?:Based on\s+)?([\d,]+)\s+reviews/i);
      if (match) {
        const reviewCount = match[1];
        root.querySelectorAll(".yotpo-sr-bottom-line-text--right-panel").forEach(span => {
          if (span.dataset.patched === "1") return;
          span.textContent = `${reviewCount} Reviews`;
          span.dataset.patched = "1";
          changed++;
        });
      }
    }
    if (changed > 0) {
      // Reveal widget only after patching
      document.querySelectorAll(".yotpo-widget-instance").forEach(el => {
        el.classList.add("yotpo-ready");
        el.style.opacity = 1;
      });
    }
    return changed;
  }

  function runAll() {
    const isZeroReviews = hideSectionIfNoReviews();
    if (isZeroReviews) {
      syncYotpoReviews();
    }
  }

  // Initial run
  runAll();

  // On load
  window.addEventListener("load", runAll);

  // Observe Yotpo async render
  const observer = new MutationObserver(() => {
    clearTimeout(window.__yotpoPatchTimer);
    window.__yotpoPatchTimer = setTimeout(runAll, 50);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Shopify section reload events
  document.addEventListener("shopify:section:load", runAll);
  document.addEventListener("shopify:section:unload", runAll);

  // Failsafe reveal.
  // The theme keeps .product__info-wrapper .yotpo-widget-instance at opacity 0 until
  // .yotpo-ready is added, which above only happens on a successful patch. If Yotpo is
  // slow the star row would otherwise stay invisible for the whole session.
  const REVEAL_DEADLINE_MS = 3000;
  setTimeout(function revealRegardless() {
    document.querySelectorAll(".yotpo-widget-instance").forEach(el => {
      el.classList.add("yotpo-ready");
    });
  }, REVEAL_DEADLINE_MS);
});


document.addEventListener("DOMContentLoaded", function () {
  function isZeroReviews() {
    const reviewLabel = document.querySelector('.reviews-qa-label');
    return reviewLabel && reviewLabel.textContent.includes("0 Reviews");
  }

  // ⭐ Force rating to 4.8
  function patchYotpoRating(root = document) {
    // Check if root is a valid DOM element
    if (!(root instanceof Element) && !(root instanceof Document)) {
      root = document;
    }
    
    // Previously rewrote this score to a hardcoded "4.8". Disabled so Yotpo's real
    // aggregate stands and stays consistent with the star row above.
    return;
  }

  // 🧹 Remove "Based on"
  function patchYotpoBasedOn(root = document) {
    // Check if root is a valid DOM element
    if (!(root instanceof Element) && !(root instanceof Document)) {
      root = document;
    }
    
    const el = root.querySelector(".yotpo-bottom-line-basic-text");
    if (el && el.dataset.cleaned !== "1") {
      el.textContent = el.textContent.replace(/^Based on\s*/i, "");
      el.dataset.cleaned = "1";
    }
  }

  function runAll(root = document) {
    // Check if root is a valid DOM element
    if (!(root instanceof Element) && !(root instanceof Document)) {
      root = document;
    }
    
    if (isZeroReviews()) {
      patchYotpoRating(root);
      patchYotpoBasedOn(root);
    }
  }

  // Run once on load
  runAll();

  window.addEventListener("load", runAll);

  // Observe Yotpo async renders
  const observer = new MutationObserver((mutations) => {
    clearTimeout(window.__yotpoPatchTimer3);
    window.__yotpoPatchTimer3 = setTimeout(() => {
      // Check each mutation for added nodes
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) { // Element node
            runAll(node);
          }
        });
      });
      // Also run on the whole document
      runAll();
    }, 50);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Shopify section reload
  document.addEventListener("shopify:section:load", (e) => {
    if (e.detail && e.detail.container) {
      runAll(e.detail.container);
    } else {
      runAll();
    }
  });
});
 

(function () {
  function patchYotpoRatings(root = document) {
    // Check if root is a valid DOM element
    if (!(root instanceof Element) && !(root instanceof Document)) {
      root = document;
    }
    
    // Previously rewrote this average score to a hardcoded "4.8". Disabled so Yotpo's
    // real value stands.
    return;
  }

  function run(root = document) { 
    // Check if root is a valid DOM element
    if (!(root instanceof Element) && !(root instanceof Document)) {
      root = document;
    }
    patchYotpoRatings(root); 
  }

  document.addEventListener("DOMContentLoaded", run);
  window.addEventListener("load", run);

  const obs = new MutationObserver((mutations) => {
    clearTimeout(window.__yotpoPatchTimer);
    window.__yotpoPatchTimer = setTimeout(() => {
      // Check each mutation for added nodes
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1) { // Element node
            run(node);
          }
        });
      });
      // Also run on the whole document
      run();
    }, 50);
  });
  obs.observe(document.body, { childList: true, subtree: true });

  document.addEventListener("shopify:section:load", (e) => {
    if (e.detail && e.detail.container) {
      run(e.detail.container);
    } else {
      run();
    }
  });
})();


// old -review js
//   document.addEventListener("DOMContentLoaded", function () {
//     document.body.addEventListener("click", function (e) {
//       const btn = e.target.closest(".yotpo-sr-bottom-line-summary");
//       if (btn) {
//         e.preventDefault();
//         const reviewSection = document.querySelector(".yotpo-widget-instance-custom");
//         if (reviewSection) {
//           reviewSection.scrollIntoView({ behavior: "smooth", block: "start" });
//         }
//       }
//     });
//   });

 
// document.addEventListener("DOMContentLoaded", function () {
//     const observer = new MutationObserver(() => {
//       const starsContainer = document.querySelector('.star-container')?.parentElement?.parentElement;
//       if (starsContainer && !starsContainer.querySelector('.custom-rating-text')) {
//         document.querySelectorAll('.star-container').forEach((span, index) => {
//           if(index == 4) {
            
//             span.classList.remove('yotpo-sr-star-empty');
//             span.classList.add('yotpo-sr-star-half');
//             span.innerHTML= `<defs>
// 		    <linearGradient id="yotpo_stars_gradient_0.8563926457371702">
// 		        <stop offset="51%" stop-color="#F0CD66"></stop>
// 		        <stop stop-opacity="1" offset="51%" stop-color="#FFFFFF"></stop>
// 			</linearGradient>
// 		</defs><path style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="#F0CD66" fill="url('#yotpo_stars_gradient_0.8563926457371702')"></path>`;
//           } else {
//             span.classList.remove('yotpo-sr-star-empty');
//             span.classList.add('yotpo-sr-star-full');
//             span.innerHTML= `<defs>
//                 <linearGradient id="yotpo_stars_gradient_0.28508708046692344">
//                     <stop offset="100%" stop-color="#F0CD66"></stop>
//                     <stop stop-opacity="1" offset="100%" stop-color="#FFFFFF"></stop>
//               </linearGradient>
//             </defs><path style="pointer-events: none;" d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" stroke="#F0CD66" fill="url('#yotpo_stars_gradient_0.28508708046692344')"></path>`;
//           }
          
//         });
//         const textEl = document.createElement('span');
//         textEl.className = 'custom-rating-text';
//         textEl.textContent = 'Rated 4.8 out of 5 stars';
//         starsContainer.appendChild(textEl);
//       }
//     });

//     observer.observe(document.body, { childList: true, subtree: true });
// });




// document.addEventListener("DOMContentLoaded", function () {
//   function hideSectionIfNoReviews() {
//     const reviewLabel = document.querySelector('.reviews-qa-label');
//     const reviewAppsection = reviewLabel?.closest('.shopify-section');
//     const yotpoSection = document.querySelector('.yotpo-widget-instance-custom')?.closest('.shopify-section');

//     if (reviewLabel && reviewLabel.textContent.includes("0 Reviews")) {
//       if (yotpoSection) yotpoSection.style.display = "block";
//       if (reviewAppsection) reviewAppsection.style.display = "none";
//       return true; // 0 reviews → RUN syncYotpoReviews
//     } else {
//       if (yotpoSection) yotpoSection.style.display = "none";
//       if (reviewAppsection) reviewAppsection.style.display = "block";
//       return false; // has reviews → DON'T run syncYotpoReviews
//     }
//   }

//   function syncYotpoReviews(root = document) {
//     let changed = 0;
//     const baseText = root.querySelector(".yotpo-bottom-line-basic-text");
//     if (baseText) {
//       const match = baseText.textContent.match(/Based on\s+(\d+)\s+reviews/i);
//       if (match) {
//         const reviewCount = match[1];
//         root.querySelectorAll(".yotpo-sr-bottom-line-text--right-panel").forEach(span => {
//           if (span.dataset.patched === "1") return;
//           span.textContent = `${reviewCount} Reviews`;
//           span.dataset.patched = "1";
//           changed++;
//         });
//       }
//     }
//     return changed;
//   }

//   function runAll() {
//     const isZeroReviews = hideSectionIfNoReviews();
//     if (isZeroReviews) {
//       syncYotpoReviews();
//     }
//   }

//   // Initial run
//   runAll();

//   // On load
//   window.addEventListener("load", runAll);

//   // Observe Yotpo async render
//   const observer = new MutationObserver(() => {
//     clearTimeout(window.__yotpoPatchTimer);
//     window.__yotpoPatchTimer = setTimeout(runAll, 50);
//   });
//   observer.observe(document.body, { childList: true, subtree: true });

//   // Shopify section reload events
//   document.addEventListener("shopify:section:load", runAll);
//   document.addEventListener("shopify:section:unload", runAll);
// });


// document.addEventListener("DOMContentLoaded", function () {
//   function isZeroReviews() {
//     const reviewLabel = document.querySelector('.reviews-qa-label');
//     return reviewLabel && reviewLabel.textContent.includes("0 Reviews");
//   }

//   // ⭐ Force rating to 4.8
//   function patchYotpoRating(root = document) {
//     const ratingEl = root.querySelector(".yotpo-bottom-line-left-panel.yotpo-bottom-line-score");
//     if (ratingEl && ratingEl.dataset.patched !== "1") {
//       ratingEl.childNodes.forEach(node => {
//         if (node.nodeType === 3 && node.textContent.trim().match(/^\d+(\.\d+)?$/)) {
//           node.textContent = "4.8"; // 👈 forced rating
//         }
//       });
//       ratingEl.dataset.patched = "1";
//     }
//   }

//   // 🧹 Remove "Based on"
//   function patchYotpoBasedOn(root = document) {
//     const el = root.querySelector(".yotpo-bottom-line-basic-text");
//     if (el && el.dataset.cleaned !== "1") {
//       el.textContent = el.textContent.replace(/^Based on\s*/i, "");
//       el.dataset.cleaned = "1";
//     }
//   }

//   function runAll(root = document) {
//     if (isZeroReviews()) {
//       patchYotpoRating(root);
//       patchYotpoBasedOn(root);
//     }
//   }

//   // Run once on load
//   runAll();

//   window.addEventListener("load", runAll);

//   // Observe Yotpo async renders
//   const observer = new MutationObserver(() => {
//     clearTimeout(window.__yotpoPatchTimer3);
//     window.__yotpoPatchTimer3 = setTimeout(runAll, 50);
//   });
//   observer.observe(document.body, { childList: true, subtree: true });

//   // Shopify section reload
//   document.addEventListener("shopify:section:load", runAll);
// });
 

// (function () {
//   function patchYotpoRatings(root = document) {
//     const ratingEl = root.querySelector(".avg-score.font-color-gray-darker");
//     if (ratingEl && ratingEl.dataset.patched !== "1") {
//       ratingEl.childNodes.forEach(node => {
//         if (node.nodeType === 3 && node.textContent.trim().match(/^\d+(\.\d+)?$/)) {
//           node.textContent = "4.8"; // 👈 forced rating
//         }
//       });
//       ratingEl.dataset.patched = "1";
//     }
//   }

//   function run() { patchYotpoRatings(); }

//   document.addEventListener("DOMContentLoaded", run);
//   window.addEventListener("load", run);

//   const obs = new MutationObserver(() => {
//     clearTimeout(window.__yotpoPatchTimer);
//     window.__yotpoPatchTimer = setTimeout(run, 50);
//   });
//   obs.observe(document.body, { childList: true, subtree: true });

//   document.addEventListener("shopify:section:load", run);
// })();